import { IStore } from 'store/configureStore';
import { selectActivitiesState } from 'modules/settings/submodules/clients/activities/store/selectors';

export const selectIsActivityStatusUpdating = (state: IStore) => {
    const activitiesState = selectActivitiesState(state);
    return activitiesState.isActivityStatusUpdating;
};
